import React, { Component } from "react";
import { connect } from "react-redux";
import MetisMenu from "react-metismenu";
import _ from "lodash";
import i18next from "i18next";

import { setEnableMobileMenu } from "reducers/ThemeOptions";
import { applyColor } from "utils/apply-color";
import { MainNav } from "./dataMainNav";

class VerticalNavWrapper extends Component {
  state = {
    readMenu: []
  };

  componentDidMount = () => {
    if (!_.isEmpty(this.props.profile)) {
      this.setState({
        readMenu: this.buildMenuFromAPI(this.props.menuStructure)
      });
    } else {
      this.setState({
        readMenu: []
      });
    }
  };

  componentDidUpdate = (pp) => {
    if (!_.isEqual(pp.profile, this.props.profile) || 
        !_.isEqual(pp.menuStructure, this.props.menuStructure) ||
        pp.currentLanguage !== this.props.currentLanguage) {
      if (!_.isEmpty(this.props.profile)) {
        this.setState({
          readMenu: this.buildMenuFromAPI(this.props.menuStructure)
        });
      } else {
        this.setState({
          readMenu: []
        });
      }
    }
  };

  // Get label text based on current language
  getMenuLabel = (menuItem) => {
    const lang = i18next.language || 'en';
    if (lang === 'zh' && menuItem.LabelText_ZH) {
      return menuItem.LabelText_ZH;
    } else if (lang === 'ms' && menuItem.LabelText_MS) {
      return menuItem.LabelText_MS;
    }
    return menuItem.LabelText || '';
  };

  // Find matching route config from MainNav by KeyName
  findRouteConfig = (keyName) => {
    const findInNav = (navItems) => {
      for (const item of navItems) {
        if (item.module === keyName) {
          return item;
        }
        if (item.content) {
          const found = findInNav(item.content);
          if (found) return found;
        }
      }
      return null;
    };
    return findInNav(MainNav);
  };

  // Build menu structure from API response
  buildMenuFromAPI = (menuItems = []) => {
    const buildMenu = (items) => {
      return items
        .filter(item => item.StatusX === 1)
        .map(item => {
          const routeConfig = this.findRouteConfig(item.KeyName);
          
          if (!routeConfig) {
            return null;
          }

          const menuItem = {
            ...routeConfig,
            label: this.getMenuLabel(item),
            icon: item.Icon || routeConfig.icon
          };

          // Handle child items
          if (item.ChildItems && item.ChildItems.length > 0) {
            const childContent = buildMenu(item.ChildItems);
            if (childContent.length > 0) {
              menuItem.content = childContent;
            }
          }

          return menuItem;
        })
        .filter(item => item !== null);
    };

    return buildMenu(menuItems);
  };

  render = () => {
    return (
      <>
        <style>
          {`
            .vertical-nav-menu .metismenu-container .metismenu-link.active{ background: ${applyColor(
              "$menuActive",
              this.props.colors
            )} }
            .vertical-nav-menu .metismenu-container .metismenu-link:hover{ background: ${applyColor(
              "$menuActive",
              this.props.colors
            )} }
          `}
        </style>
        <br />
        <MetisMenu
          content={this.state.readMenu}
          onSelected={() => this.props.setEnableMobileMenu(!this.props.enableMobileMenu)}
          activeLinkFromLocation
          className="vertical-nav-menu"
          iconNamePrefix=""
          classNameStateIcon="pe-7s-angle-down"
        />
      </>
    );
  };
}

const mapStateToProps = (state) => ({
  data: state,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  colors: state.ClientReducer.clientInfo.styles?.colors,
  siteModules: state.ClientReducer.siteModules,
  clientInfo: state.ClientReducer.clientInfo,
  profile: state.ProfileReducer.profile,
  permissions: state.ProfileReducer.permissions,
  menuStructure: state.ProfileReducer.menuStructure,
  currentLanguage: i18next.language
});

export default connect(mapStateToProps, {
  setEnableMobileMenu
})(VerticalNavWrapper);
